export interface AppSelectItem {
  label: string;
  value: string;
  [key: string]: any;
}
export enum LoginStatusEnum {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
  UNKNOWN = 'UNKNOWN',
}
export const sexOptions: AppSelectItem[] = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Unspecified', value: 'Unspecified' },
];

export const relationToMainMemberOptions: AppSelectItem[] = [
  { label: 'Unspecified', value: 'Unspecified' },
  { label: 'Adult Dependant', value: 'AdultDependant' },
  { label: 'Self', value: 'Self' },
  { label: 'Aunt', value: 'Aunt' },
  { label: 'Brother', value: 'Brother' },
  { label: 'Child', value: 'Child' },
  { label: 'Child Dependant', value: 'ChildDependant' },
  { label: 'Common Law Spouse', value: 'CommonLawSpouse' },
  { label: 'Daughter', value: 'Daughter' },
  { label: 'Father', value: 'Father' },
  { label: 'Grand Parent', value: 'GrandParent' },
  { label: 'Husband', value: 'Husband' },
  { label: 'Mother', value: 'Mother' },
  { label: 'Nephew', value: 'Nephew' },
  { label: 'Niece', value: 'Niece' },
  { label: 'Sister', value: 'Sister' },
  { label: 'Son', value: 'Son' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Uncle', value: 'Uncle' },
  { label: 'Wife', value: 'Wife' },
];

export const languageOptions: AppSelectItem[] = [
  { label: 'English', value: 'English' },
  { label: 'Afrikaans', value: 'Afrikaans' },
];

export const communicationTypeOptions: AppSelectItem[] = [
  { label: 'Email', value: 'Email' },
  { label: 'SMS', value: 'SMS' },
];

export const insuranceTypeOptions: AppSelectItem[] = [
  { label: 'Medical Scheme', value: 'MedicalScheme' },
  { label: 'Private', value: 'Private' },
  //{ label: 'COID', value: 'Coid' },
  //{ label: 'Insurance', value: 'Insurance' },
  //{ label: 'Company', value: 'Company' },
];

export const documentFormatOptions: AppSelectItem[] = [{ label: '1', value: '1' }];

export const completedByOptions: AppSelectItem[] = [
  { label: 'Guardian', value: 'Guardian' },
  { label: 'Patient', value: 'Patient' },
];
